export function closeParent(): void {
  window.parent.postMessage({ type: "light-flow-close", payload: {} }, "*");
}
